<template>
  <a
    name="gp-tab"
    class="gp-tabs-nav-item typo-button14 typo-medium text-light-low"
    :class="[aClass, {'gp-tabs-nav-item-active': index == activeIndex }, { 'disabled': disabled }]"
    @click="onClick"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "GpTab",
  props: {
    label: String,
    index: [String, Number],
    activeIndex: [String, Number],
    aClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      this.$emit("click", this.index);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
